module.exports = __webpack_public_path__ + "static/img/gd-01.c3fb42e0.jpg";